(function() {
  var DISCOUNTS = [
    {
      code: 'LOVEISLOVE',
      type: 'percentage',
      amount: 0.2,
      products: ['all'],
      minPriceAmount: 2000,
    },
    {
      code: 'SHOPSMALL',
      type: 'percentage',
      amount: 0.15,
      products: ['all'],
      minPriceAmount: 3500,
    },
    {
      code: 'SFANDEASTBAY20201015',
      type: 'percentage',
      amount: 0.2,
      products: ['all'],
      minPriceAmount: 3500,
    },
    {
      code: 'SHOPLOCAL',
      type: 'percentage',
      amount: 0.2,
      products: ['all'],
      minPriceAmount: 3500,
    },
    {
      code: 'SFSUTROJULY4TH',
      type: 'cash',
      amount: 1000,
      products: ['san-francisco-sutro-tower-laser-cut-wooden-3d-model-15in'],
    },
    {
      code: 'SUTRO40',
      type: 'percentage',
      amount: 0.4,
      products: ['san-francisco-sutro-tower-laser-cut-wooden-3d-model-15in'],
    },
    {
      code: 'SUTRO30',
      type: 'percentage',
      amount: 0.3,
      products: ['san-francisco-sutro-tower-laser-cut-wooden-3d-model-15in'],
    },
    {
      code: 'SUTROCASH20',
      type: 'cash',
      amount: 2000,
      products: ['san-francisco-sutro-tower-laser-cut-wooden-3d-model-15in'],
    },
    {
      code: 'SUTRO25',
      type: 'percentage',
      amount: 0.25,
      products: ['san-francisco-sutro-tower-laser-cut-wooden-3d-model-15in', 'sutro-tower-july-4th-1973-newspaper-ad-replica-poster'],
    },
    {
      code: 'BESTTOWER25',
      type: 'percentage',
      amount: 0.25,
      products: ['san-francisco-sutro-tower-laser-cut-wooden-3d-model-15in', 'sutro-tower-july-4th-1973-newspaper-ad-replica-poster'],
    },
    {
      code: 'BESTTOWER40',
      type: 'percentage',
      amount: 0.4,
      products: ['san-francisco-sutro-tower-laser-cut-wooden-3d-model-15in'],
    },
    {
      code: 'SUTROGIVEAWAY',
      type: 'percentage',
      amount: 0.5,
      products: ['san-francisco-sutro-tower-laser-cut-wooden-3d-model-15in'],
    },
    {
      code: 'SUTROSMALL',
      type: 'percentage',
      amount: 0.4,
      products: ['san-francisco-sutro-tower-laser-cut-wooden-3d-model-15in', 'sutro-tower-july-4th-1973-newspaper-ad-replica-poster'],
    },
  ];

  var $ = window.$;

  // I'll store the parsed product JSON on page load
  var currentProduct;

  var LOG_MESSAGE = '[DISCOUNTS-IN-PRODUCT-PAGE]';

  var SELECTORS = {
    'productSectionContainer': '#ProductSection-product-template',
    'productJson': '#ProductJson-product-template',
  };

  function getCookie(cname) {
    var name = cname + '=';
    var ca = window.document.cookie.split(';');
    for(var i = 0; i < ca.length; i += 1) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  };

  // https://stackoverflow.com/a/901144
  function getParameterByName(name) {
    var url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    var results = regex.exec(url);
    if (!results) {
      return null;
    }
    if (!results[2]) {
      return ''
    };
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  function getPriceSelectors() {
    var $container = $(SELECTORS.productSectionContainer);
    var $priceContainer = $('[data-price]', $container);

    var $discountPriceContainer = $('.discount-price-container', $container);
    var $discountGenericMessage = $('.discount-generic-message', $discountPriceContainer);
    var $discountAppliedMessage = $('.discount-applied-message', $discountPriceContainer);
    var $priceWithDiscountCode = $('.discounted-price', $discountAppliedMessage);
    var $discountCode = $('.discount-code', $discountAppliedMessage);

    // "regular" and "sale" (compare_at) prices
    var $allPrices = $('[data-sale-price], [data-regular-price]', $priceContainer);

    return {
      $discountGenericMessage: $discountGenericMessage,
      $discountAppliedMessage: $discountAppliedMessage,
      $priceWithDiscountCode: $priceWithDiscountCode,
      $discountCode: $discountCode,
      $allPrices: $allPrices,
    };
  }

  function updateOriginalPriceAndDiscountHTML(discountedPrice, discount) {
    var priceSelectors = getPriceSelectors();

    var formattedDiscountedPrice = window.theme.Currency.formatMoney(discountedPrice, window.theme.moneyFormat);

    priceSelectors.$priceWithDiscountCode.text(formattedDiscountedPrice);
    priceSelectors.$discountCode.text(discount.code);
    priceSelectors.$allPrices.css('text-decoration', 'line-through');
    priceSelectors.$discountGenericMessage.hide();
    priceSelectors.$discountAppliedMessage.show();
  }

  function resetOriginalPriceAndDiscountHTML() {
    var priceSelectors = getPriceSelectors();

    priceSelectors.$priceWithDiscountCode.text('');
    priceSelectors.$discountCode.text('');
    priceSelectors.$allPrices.css('text-decoration', '');
    priceSelectors.$discountAppliedMessage.hide();
    priceSelectors.$discountGenericMessage.show();
  }

  function showDiscount(variant, discount) {
    if (discount.minPriceAmount && (variant.price <= discount.minPriceAmount)) {
      // do nothing if the price if less than minPriceAmount
      return;
    }

    // Do not try to show discounts if variant is sold out
    if (!variant.available) {
      return;
    }

    var discountedPrice = variant.price;

    if (discount.type === 'cash') {
      discountedPrice -= discount.amount;
    } else if (discount.type === 'percentage') {
      discountedPrice -= variant.price * discount.amount;
    }

    if (variant.price === discountedPrice) {
      return;
    }


    updateOriginalPriceAndDiscountHTML(discountedPrice, discount);
    // Hide div that is part of the Sutro Tower model product description
    $('#product-description__limited-time-discount').hide();
  };

  function isDiscountValidForCurrentVariant(variant, discount) {
    return ($.inArray(currentProduct.handle, discount.products) >= 0 || $.inArray('all', discount.products) >= 0);
  };

  function checkIfDiscountAvailable(variant) {
    var cookieDiscountCode = getCookie('discount_code');

    if (!cookieDiscountCode) {
      return;
    }

    cookieDiscountCode = cookieDiscountCode.toUpperCase();

    for(var i = 0; i < DISCOUNTS.length; i += 1) {
      var discount = DISCOUNTS[i];
      if(discount.code.toUpperCase() === cookieDiscountCode && isDiscountValidForCurrentVariant(variant, discount)) {
        showDiscount(variant, discount);
        break;
      }
    }
  }

  $(window.document).ready(function() {
    try {
      currentProduct = JSON.parse($(SELECTORS.productJson).html());
    } catch (err) {
      console.log(LOG_MESSAGE, 'ERROR: Could not parse ' + SELECTORS.productJson, err);
      return;
    }

    var variantId = getParameterByName('variant');

    try {
      variantId = parseInt(variantId);
    } catch {
      variantId = null;
    }

    var variant = currentProduct.variants[0];

    if (variantId) {
      // find variant in product object
      for (var i = 0; i < currentProduct.variants.length; i += 1) {
        if (currentProduct.variants[i].id === variantId) {
          variant = currentProduct.variants[i];
          break;
        }
      }
    }

    checkIfDiscountAvailable(variant);

    $(SELECTORS.productSectionContainer).on('variantChange', function(evt) {
      resetOriginalPriceAndDiscountHTML();

      if (evt.variant) {
        checkIfDiscountAvailable(evt.variant);
      } else {
        console.log(LOG_MESSAGE, 'ERROR: No variant in variantChange event', evt);
      }
    })
  });
}());
